import { graphqlClient } from 'features/graphql';
import { BrowserRouter as Router } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { ApolloProvider } from '@apollo/client';
import { AppRoutes } from 'route';
import { AccountProvider } from 'features/auth';
import { TopBar } from 'features/layout/TopBar';
import { FootBar } from 'features/layout/FootBar';
import { ZoomProvider } from 'hooks/ZoomContext';
import { usePathRedirect } from 'hooks/usePathRedirect';
import { Alert, Col, Container, Row } from 'react-bootstrap';
import Image from './logo.png';

const ErrorFallback = () => {
  return (
    <Container fluid className="mt-2 p-0" style={{ width: '600px', background: 'white' }}>
      <Row>
        <Col style={{ border: 'double #008000' }}>
          <img src={Image} alt="Logo" className="mt-3" />

          <Alert className="fs-5 my-3" variant="danger">
            システムに何らかの問題が発生しました。
          </Alert>
        </Col>
      </Row>
    </Container>
  );
};

const AppContent = () => {
  usePathRedirect(); // 旧パスから新パスへの自動リダイレクト
  return (
    <>
      <TopBar />
      <AppRoutes />
      <FootBar />
    </>
  );
};

function App() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <ApolloProvider client={graphqlClient}>
        <AccountProvider>
          <ZoomProvider>
            <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
              <AppContent />
            </Router>
          </ZoomProvider>
        </AccountProvider>
      </ApolloProvider>
    </ErrorBoundary>
  );
}

export default App;
